module.exports = __webpack_public_path__ + "img/jdt-card.4437d0ac.png";